/**
 * La tablet: UNA cuenta y dos modos (dirección, 29/9/2026).
 *
 * «La sesión de tablet tiene que ser una única y que permita cambiar de
 * consentimientos a LOPD según queramos usarlo… según el día usaremos uno u
 * otro.» Antes había dos iPads con dos cuentas y cada rol iba a su quiosco
 * fijo (`tablet` → /firma-lopd, `tablet_consent` → /firma-consent). Ahora
 * cualquiera de las dos cuentas entra a un selector con dos botones y la
 * elección se recuerda EN ESE DISPOSITIVO: el iPad vuelve solo al modo del
 * día, y otro iPad con la misma cuenta puede estar en el otro.
 *
 * Se recuerda en localStorage, que no siempre está (Safari privado, datos
 * borrados): todo va en try/catch y, si no se puede leer, se enseña el
 * selector, que es el lado seguro. El modo NO se borra al cerrar sesión: es
 * del iPad, no de la sesión.
 *
 * El servidor no mira el modo: las dos cuentas pueden usar los dos quioscos
 * (`tablet_consent_router._require_tablet_user`; el de la LOPD es público) y
 * ninguna entra en el programa del equipo (`get_current_staff_user`).
 */
import { isTablet, isTabletConsent } from './roles';

export const RUTA_SELECTOR_TABLET = '/tablet';

/** Los dos modos y a qué quiosco lleva cada uno. */
export const MODOS_TABLET = {
  consentimientos: '/firma-consent',
  lopd: '/firma-lopd',
};

const CLAVE = 'cp_modo_tablet';

/** ¿Es una de las cuentas del iPad (cualquiera de los dos roles)? */
export function esCuentaDeTablet(user) {
  return isTablet(user) || isTabletConsent(user);
}

/** El modo recordado en este dispositivo, o null. */
export function modoTabletGuardado() {
  try {
    const modo = window.localStorage.getItem(CLAVE);
    return Object.prototype.hasOwnProperty.call(MODOS_TABLET, modo) ? modo : null;
  } catch (e) {
    return null;
  }
}

/** Recuerda el modo en este dispositivo. Si no se puede, no pasa nada: el
 *  iPad entra igual al quiosco, y la próxima vez vuelve a preguntar. */
export function guardarModoTablet(modo) {
  if (!Object.prototype.hasOwnProperty.call(MODOS_TABLET, modo)) return;
  try {
    window.localStorage.setItem(CLAVE, modo);
  } catch (e) {
    /* sin almacenamiento: se pregunta la próxima vez */
  }
}

/** «Cambiar de modo»: se olvida el del día y se vuelve al selector (así, si
 *  el iPad se recarga en el selector, no se va solo al modo de antes). */
export function olvidarModoTablet() {
  try {
    window.localStorage.removeItem(CLAVE);
  } catch (e) {
    /* nada que olvidar */
  }
}

/** Adónde va la tablet al entrar: su modo recordado, o el selector. */
export function rutaDeLaTablet() {
  const modo = modoTabletGuardado();
  return modo ? MODOS_TABLET[modo] : RUTA_SELECTOR_TABLET;
}
